import { memo } from 'react'

import CustomImage from '../images/image'

const BenefitCard = ({ image, title, description }) => (
  <div className="benefit-card-item">
    {image && (
      <div className="benefit-item-image-container">
        <CustomImage
          className="benefit-item-image"
          media={image.data.attributes}
          layout="fill"
          objectFit="fill"
          shimmer
        />
      </div>
    )}
    {title && <div className="benefit-item-title">{title}</div>}
    {description && <div className="benefit-item-description">{description}</div>}
  </div>
)

export default memo(BenefitCard)
